module.exports = __webpack_public_path__ + "static/fwc-11dcc153165016351d6536ef6a2580aa.png";